import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import 'rxjs/add/observable/of';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'primeng/components/common/messageservice';
import { isNullOrUndefined } from 'util';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';


@Injectable()
export class DadosPrestadorService extends BaseService {

  private imgPerfilCached: string;
  private observable;
  private subject;

  constructor(
    public http: HttpClient,
    public messageService: MessageService
  ) {
    super(http, messageService);
    this.subject = new BehaviorSubject('');
  }

  buscarDadosCadastrais() {
    const url = environment.urlApi + 'prestador/' + 'dados-cadastrais';

    return this.get(url);
  }

  carregarImagemPerfil(): Observable<void> {
    let imagemPerfil = 'assets/images/img-perfil.png';

    return this.carregaImgServ().map(
      response => {
        const urlImagemUsuario = response.data;

        if (urlImagemUsuario != null) {
          imagemPerfil = 'data:image/png;base64,' + urlImagemUsuario;
        }

        this.imgPerfilCached = imagemPerfil;
        this.subject.next(imagemPerfil);
      }
    );
  }

  carregaImgServ() {
    const url = environment.urlApi + 'prestador/' + 'imagem';

    return this.get(url);
  }

  getImgPerfilCached() {
    if (isNullOrUndefined(this.imgPerfilCached)) {
      if (!this.observable) {
        this.observable = this.carregarImagemPerfil();
        this.observable.subscribe();
      }

      return this.subject.asObservable();
    } else {
      return Observable.of(this.imgPerfilCached);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dados-prestador/dados-prestador.service.ts